import {
  GET_CONNECTIONS,
  GET_CONNECTIONS_SUCCESS,
  CONNECTIONS_ERROR,
} from '../constants/action-types/connections';

// eslint-disable-next-line import/prefer-default-export
export const getConnections = () => ({
  type: GET_CONNECTIONS,
});

export const getConnectionsSuccess = data => ({
  type: GET_CONNECTIONS_SUCCESS,
  data,
});

export const connectionsError = () => ({
  type: CONNECTIONS_ERROR,
});
